import { i18n } from '@/services/i18n';
import ROUTE_NAMES from '@/router/scanner/ROUTE_NAMES';
import DocumentsScannerView from '@/views/scanner/DocumentsScannerView.vue';
import ScanDocumentsView from '@/views/scanner/ScanDocumentsView.vue';

export default [
  {
    path: '/scan-documents',
    name: ROUTE_NAMES.SCAN_DOCUMENTS,
    component: ScanDocumentsView,
    meta: {
      authOnly: true,
      title: i18n.t('GENERAL.SCANNER'),
    },
  },
  {
    path: '/documents-scanner',
    name: ROUTE_NAMES.DOCUMENTS_SCANNER,
    component: DocumentsScannerView,
    meta: {
      authOnly: true,
      title: i18n.t('GENERAL.DOCUMENTS_SCANNER'),
    },
  },
];
